var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoSearch = function SvgIcoSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M8 16a8 8 0 1 1 6.32-3.094l5.387 5.387a1 1 0 0 1-1.414 1.414l-5.387-5.387A7.97 7.97 0 0 1 8 16m0-2A6 6 0 1 0 8 2a6 6 0 0 0 0 12",
    clipRule: "evenodd"
  })));
};
export default SvgIcoSearch;